import sdkProvider from "./sdk-provider";
import renderQRCode from "./renderQRcode";
import updateAppPlayStoreLinks from "./updateAppPlayStoreLinks";

const getFloor = (webContext) => {
  const floor =
    webContext.floor === "default" || webContext.floor === "women"
      ? "women"
      : "men";

  return floor;
};

export async function generateAppStoreLinks() {
  const webContext = window.asos.webContext.getWebContext();
  const floor = getFloor(webContext);
  const affId = webContext.affiliateId
    ? `&affid=${webContext.affiliateId}`
    : "";

  const identity = await sdkProvider("identity");
  const customerId = await identity?.customer?.customerId();

  const customerRef = customerId ? `&custref=${customerId}` : "";
  const isDesktop = webContext.platform === "desktop";

  //Initializing Smart Script arguments
  const oneLinkURL = "https://asos-medialabs.onelink.me/PXyX/";
  // If a media source key is NOT FOUND on the link and NO default value is found, the script will return a null string
  const mediaSource = { keys: ["media"], defaultValue: "qr_code" };
  const channel = { keys: ["channel"], defaultValue: "web" };
  const campaign = { keys: ["campaign"], defaultValue: "download_the_app" };
  const deepLinkValue = {
    keys: ["deepLink"],
    defaultValue: encodeURIComponent(
      `asos://home?channelref=web_dta_qr&floor=${floor}${affId}${customerRef}`
    ),
  };

  if (isDesktop) {
    renderQRCode(oneLinkURL, mediaSource, campaign, deepLinkValue, channel);
  } else {
    updateAppPlayStoreLinks(
      oneLinkURL,
      campaign,
      floor,
      affId,
      customerRef,
      channel
    );
  }
}
